import { render, staticRenderFns } from "./unroll_element.vue?vue&type=template&id=8c6a780c&scoped=true&"
import script from "./unroll_element.vue?vue&type=script&lang=js&"
export * from "./unroll_element.vue?vue&type=script&lang=js&"
import style0 from "./unroll_element.vue?vue&type=style&index=0&id=8c6a780c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6a780c",
  null
  
)

export default component.exports